import { render, staticRenderFns } from "./applyList.vue?vue&type=template&id=2bf75876&scoped=true&"
import script from "./applyList.vue?vue&type=script&lang=js&"
export * from "./applyList.vue?vue&type=script&lang=js&"
import style0 from "./applyList.vue?vue&type=style&index=0&id=2bf75876&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf75876",
  null
  
)

export default component.exports